import React from "react";
import {
  Button,
  Card,
  CardFooter,
  CardTitle,
  Content,
  Label,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";
import { Link } from "react-router-dom";

import {
  normalizeWordPressUrl
} from "shared/utils/wordpressUrl";

const ErasmusNewsCard = ({
  post,
  isLoading
}) => {
  if (isLoading) {
    return (
      <Card isFullHeight>
        <Stack hasGutter>
          <StackItem>
            <Skeleton height="180px" />
          </StackItem>

          <StackItem>
            <Skeleton width="30%" />
          </StackItem>

          <StackItem>
            <Skeleton width="80%" />
          </StackItem>
        </Stack>
      </Card>
    );
  }

  if (!post) {
    return null;
  }

  const imageUrl = normalizeWordPressUrl(
    post.image
  );
  return (
    <Card isFullHeight isGlass>
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          width="100%"
          height="180"
          style={{
            display: "block",
            width: "100%",
            height: "180px",
            objectFit: "cover",
            objectPosition: "center"
          }}
        />
      )}

      <CardTitle>
        <Stack hasGutter>
          <StackItem isFilled/>
          <StackItem>
            <Label color="blue">
              Relacja
            </Label>
          </StackItem>

          <StackItem>
            <Content component="h2">
              {post.title}
            </Content>
          </StackItem>
        </Stack>
      </CardTitle>
      
      <CardFooter>
        <Button
          variant="link"
          component={Link}
          to={`/news/${post.id}`}
          isInline
        >
          Czytaj więcej →
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ErasmusNewsCard;